import { render } from "./Cbhifaqspage.vue?vue&type=template&id=3cc81037&scoped=true"
import script from "./Cbhifaqspage.vue?vue&type=script&lang=js"
export * from "./Cbhifaqspage.vue?vue&type=script&lang=js"

import "./Cbhifaqspage.vue?vue&type=style&index=0&id=3cc81037&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cc81037"]])

export default __exports__